import axios from '@/axios/globalaxios'

export const getTaskFundInfo = data =>{
    return axios({
        url: "/tradelab/openFund/getTaskFundInfo",
        method: 'post',
        data:data
    })
}
